import { MotiusDesestimarFilter } from './../../models/motius-desestimar-filter';
import { Component, OnInit, Output, EventEmitter, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-motius-desestimar-filter',
  templateUrl: './motius-desestimar-filter.component.html',
  styleUrls: ['./motius-desestimar-filter.component.scss']
})
export class MotiusDesestimarFilterComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  filter: MotiusDesestimarFilter;

  @Output() notify: EventEmitter<MotiusDesestimarFilter> = new EventEmitter<MotiusDesestimarFilter>();

  constructor(
    public thisDialogRef: MatDialogRef<MotiusDesestimarFilterComponent>,
    private i18n: I18n,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    this.filter = data.filter;
  }

  ngOnInit() {
    this.subscription = Observable.fromEvent(document, 'keypress').subscribe((e: KeyboardEvent ) => {
      if (e.key === 'Enter') {
        this.apply();
      }
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  reset() {
    this.filter.clear();
    this.apply();
  }

  apply() {
    this.filter.updated();
    this.notify.emit(this.filter);
    this.thisDialogRef.close();
  }

  dismiss() {
    this.thisDialogRef.close();
  }
}
